import {instructionsAndDocumentsFeatureTranslations} from '@features/instructions-and-documents'
import {labQualityResultFeatureTranslations} from '@features/lab-quality-result'
import {performanceDataFeatureTranslations} from '@features/performance-data'
import {shiftEventsFeatureTranslations} from '@features/shift-events'
import {shiftEventsAffiliatesFeatureTranslations} from '@features/shift-events-affiliates'
import {shiftSummaryFeatureTranslations} from '@features/shift-summary'
import {
  Localization,
  combineTranslationBundles,
  loadPackageTranslations,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import {expertSystemWidgetTranslations} from '@widgets/expert-system'
import {kpisWidgetTranslations} from '@widgets/kpis'
import {runningTimesWidgetTranslations} from '@widgets/running-times'
import {shiftEventDetailsWidgetTranslations} from '@widgets/shift-event-details'
import {shiftEventFiltersWidgetTranslations} from '@widgets/shift-event-filters'
import {siloFillLevelsWidgetTranslations} from '@widgets/silo-fill-levels'
import i18n from 'i18next'
import moment from 'moment-timezone'

const isDev = process.env.NODE_ENV === 'development'
const loader = async (filename: string) => {
  isDev && console.info(`Load Translation [${filename}]`)
  try {
    return import(`./${filename}.json`)
  } catch (err) {
    isDev && console.error(`Could not load Translation [${filename}]`, err)
    return {err}
  }
}

const externalPackageTranslations = combineTranslationBundles([
  uikitTranslations,
  expertSystemWidgetTranslations,
  kpisWidgetTranslations,
  instructionsAndDocumentsFeatureTranslations,
  labQualityResultFeatureTranslations,
  performanceDataFeatureTranslations,
  shiftEventsFeatureTranslations,
  shiftSummaryFeatureTranslations,
  runningTimesWidgetTranslations,
  shiftEventDetailsWidgetTranslations,
  shiftEventFiltersWidgetTranslations,
  shiftEventsAffiliatesFeatureTranslations,
  siloFillLevelsWidgetTranslations
])

const supportedLngs: LanguageCode[] = [
  'bs-BA',
  'de-DE',
  'en-US',
  'es-ES',
  'fr-FR',
  'hu-HU',
  'it-IT',
  'kk-KZ',
  'no-NO',
  'nl-NL',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'sv-SE',
  'th-TH'
]

export async function init() {
  i18n.on('languageChanged', (lng) => {
    // keep i18n and moment in sync
    moment.locale(lng)
  })

  await Localization({
    fallbackLng: 'en-US',
    supportedLngs,
    detection: {
      order: ['localStorage', 'cookie', 'navigator']
    },
    // when a translation is empty string "" this will result in using the fallback language translation
    returnEmptyString: false,
    backend: {
      loader
    }
  })

  void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDev})
  setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDev})
}
